import { render, staticRenderFns } from "./SortByDesktop.vue?vue&type=template&id=5b89ebb6&"
import script from "./SortByDesktop.vue?vue&type=script&lang=js&"
export * from "./SortByDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports